export enum EPeriodLists {
  FUTURE = 'FUTURE',
  PAST = 'PAST',
};



export default EPeriodLists;
